export default __webpack_public_path__ + "static/windmill-mountain-7fc0b39ba54267f609edf9d920823397.jpg";